import { render, staticRenderFns } from "./MenuTeacher.vue?vue&type=template&id=06cfb834&scoped=true"
import script from "./MenuTeacher.vue?vue&type=script&lang=js"
export * from "./MenuTeacher.vue?vue&type=script&lang=js"
import style0 from "./MenuTeacher.vue?vue&type=style&index=0&id=06cfb834&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cfb834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06cfb834')) {
      api.createRecord('06cfb834', component.options)
    } else {
      api.reload('06cfb834', component.options)
    }
    module.hot.accept("./MenuTeacher.vue?vue&type=template&id=06cfb834&scoped=true", function () {
      api.rerender('06cfb834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/MenuTeacher.vue"
export default component.exports